import React, {Component} from "react";
import ButtonIcon from "../../button";
import "./header-with-control.css";
export class HeaderWithControl extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displaySearch: false,
        };
    }
    DisplaySearhBox() {
        this.setState(prevState => {
            const updatedDisplaySearch = !prevState.displaySearch;
            this.props.displaySearchBox(this.props.title, updatedDisplaySearch);
            return {displaySearch: updatedDisplaySearch};
        });
    }
    render(){
        return(
            <>
                <div className="header-with-control-container">
                    <h1>{this.props.title}</h1>
                    <div className="header-with-control-btn">
                        <ButtonIcon onClick={this.DisplaySearhBox.bind(this)} iconLeft="file-magnifying-glass" iconSize="17px" customClassName="header-option-list header-filter-button" labelName="Search"/>
                        <ButtonIcon onClick={!this.props.isReadOnly ? () => this.props.extractAction() : () => { }} iconLeft="cloud-arrow-down" iconSize="17px" customClassName={`${!this.props.isReadOnly ? "header-option-list" : ""} header-filter-button`} labelName="Extract List"
                            isDisable={this.props.isReadOnly && !this.props.isReadAndExtractOnly && !this.props.isReadAndWrite}/>
                    </div>
                </div>
                {this.props.children}
            </>
        )
    }
}